import React from 'react';

import { Heading } from '@klp/design/Heading';
import { Main } from '@klp/layout';

import { ContractManagementAppBar } from '../components/ContractManagementAppBar';
import { ContractManagementContent } from '../components/ContractManagementContent';

export const ContractManagementView: React.FC = () => {
    return (
        <Main>
            <Heading
                klpHeadingLevel="TWO"
                translation="contractManagement.title"
            />
            <ContractManagementAppBar />
            <ContractManagementContent />
        </Main>
    );
};

ContractManagementView.displayName = 'Contract View';
